import { Drawer, type DrawerProps } from "@mui/material";
import { type PropsWithChildren } from "react";

const slotProps: DrawerProps["slotProps"] = {
  paper: {
    style: {
      height: "auto",
      borderRadius: "var(--radius-4xl)",
      background: "#fff",
      boxShadow:
        "0 -1px 12px 0 rgba(0, 0, 0, 0.08), 0 -4px 12px 0 rgba(0, 0, 0, 0.04)",
    },
    ref: (node: HTMLDivElement) => {
      const observer = new ResizeObserver(([entry]) => {
        document.body.style.setProperty(
          "--drawer-height",
          `${entry.target.getBoundingClientRect().height}px`,
        );
      });

      observer.observe(node);

      return () => {
        observer.disconnect();
        document.body.style.setProperty("--drawer-height", "0");
      };
    },
  },
};

export const PersistentDrawer = ({
  children,
  ...props
}: PropsWithChildren<DrawerProps>) => {
  return (
    <Drawer
      slotProps={slotProps}
      anchor="bottom"
      variant="persistent"
      open
      {...props}
    >
      <div className="w-full">{children}</div>
    </Drawer>
  );
};
